/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeValueForNumber extends models.AttributeValueBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeValueForNumber");
    }

    getFixupPrototypeFunction() { return AttributeValueForNumber.fixupPrototype; }

    static newInstance(model: Partial<AttributeValueForNumber>): AttributeValueForNumber {
        let obj = Object.assign(new AttributeValueForNumber(), model);
        AttributeValueForNumber.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeValueForNumber>): AttributeValueForNumber {
        if (!model) return null;
        return AttributeValueForNumber.newInstance(<AttributeValueForNumber> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeValueForNumber) {
        if (!obj) return;

        models.AttributeValueForNumber.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeValueForNumber): boolean {
        if (models.AttributeValueBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeValueForNumber.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.value === undefined) {
            this.value = 0;
        }
    }

    /**
     * Values for the Attribute
     */
    value: number;

}
